import { Skeleton } from 'src/shared/components/ui/skeleton'

export const ProductLoadingSkeleton = () => {
  return (
    <div className="w-full min-h-dvh p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <Skeleton className="h-10 w-32 mb-6" />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <Skeleton className="h-[600px] w-full" />
          <Skeleton className="h-[600px] w-full" />
        </div>
      </div>
    </div>
  )
}

